import Axios from "axios";
import * as React from "react";
import {useState} from "react";
import { Button } from "react-bootstrap";
import { CustomError } from "../Models/CustomError";
import { Note as NoteModel } from "../Models/Note";
import { isCustomError } from "../Utils";
export const Admin: React.FunctionComponent = (): JSX.Element => {
    const [downloadLink, setDownloadLink] = useState("");
    const [newTag, setNewTag] = useState("");
    const [postErrors, setPostErrors] = useState<CustomError>();
    const onAddNewTag = async () => {
        if (newTag === "") {
            setPostErrors({ errors: ["Please enter a value!"] });
            return;
        }
        try {
            await Axios.post(`${process.env.REACT_APP_API_URL}/api/v1/tags`, {
                name: newTag,
            });
        } catch (errors) {
            if(isCustomError(errors)){
                setPostErrors(errors);
            }
        }
    };


    const onDownload = async (
        event: React.MouseEvent<HTMLElement, MouseEvent>
    ) => {
        event.preventDefault();
        try {
            const response = await Axios.get(
                process.env.REACT_APP_API_URL + "/api/v1/notes"
            );
            let notes = response.data as NoteModel[];

            var json = JSON.stringify(notes);
            var blob = new Blob([json], { type: "application/json" });

            // this part avoids memory leaks
            if (downloadLink !== "") window.URL.revokeObjectURL(downloadLink);

            // update the download link state
            setDownloadLink(window.URL.createObjectURL(blob));
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <>
            <Button variant="light" onClick={onDownload}>
                Download
            </Button>
            {downloadLink !== "" ? (
                <a
                    // this attribute sets the filename
                    download="list.json"
                    // link to the download URL
                    href={downloadLink}
                >
                    Export
                </a>
            ) : (
                <></>
            )}

            <div>
                <label>New Tag:</label>
                <input
                    value={newTag}
                    onChange={(e) => setNewTag(e.target.value)}
                ></input>
                <button className="btn btn-primary" onClick={onAddNewTag}>Add Tag</button>
                {postErrors?.errors.map((error: string) => (
                    <small className="form-text text-muted">{error}</small>
                ))}
            </div>
        </>
    );
};
